import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { enqueue } from './moengageClient';

/**
 * Tells MoEngage about SPA page changes (`handlePageChange`) whenever the
 * pathname changes. The first render is skipped — the SDK records the
 * landing page itself when it initialises.
 *
 * Renders nothing and has no effect on routing. Mount once, inside the router.
 */
export default function RouteChangeTracker() {
    const { pathname } = useLocation();
    const first = useRef(true);

    useEffect(() => {
        if (first.current) {
            first.current = false;
            return;
        }
        enqueue((sdk) => sdk.handlePageChange());
    }, [pathname]);

    return null;
}
